<template>
  <div class="upload-file">
    <el-upload
      ref="upload"
      :action="uploadFileUrl"
      :before-upload="handleBeforeUpload"
      class="upload-file-uploader"
      :file-list="fileList"
      :limit="limit"
      :headers="headers"
      :multiple="multiple"
      name="files"
      :on-exceed="handleExceed"
      :on-error="handleUploadError"
      :on-success="handleUploadSuccess"
      :show-file-list="false"
    >
      <!-- 上传按钮 -->
      <slot v-if="showOtherStyle"></slot>
      <el-button v-else size="" plain type="primary">{{ btnText }}</el-button>
      <!-- 上传提示 -->
    </el-upload>
  </div>
</template>

<script>
  export default {
    props: {
      // 允许自定义其他样式，随便传个字符串就行，quality质检开单用到
      showOtherStyle: {
        type: String,
        default: '',
      },
      // 值
      value: [String, Object, Array],
      // 大小限制(MB)
      fileSize: {
        type: Number,
        default: 20,
      },
      btnText: {
        type: String,
        default: '上传',
      },
      limit: {
        type: Number,
        default: 20,
      },
      // 文件类型, 例如['png', 'jpg', 'jpeg']
      fileType: {
        type: Array,
        default: () => [
          'png',
          'jpg',
          'jpeg',
          'doc',
          'xls',
          'ppt',
          'txt',
          'pdf',
        ],
      },
      // 是否显示提示
      isShowTip: {
        type: Boolean,
        default: true,
      },
      isId: {
        type: Boolean,
        default: false,
      },
      multiple: {
        type: Boolean,
        default: true,
      },
      type: {
        type: String,
        default: '',
      },
      fileList: {
        type: Array,
        default: () => {
          return []
        },
      },
    },
    data() {
      return {
        uploadFileUrl:
          process.env.VUE_APP_BASE_API +
          `power/system/file/upload?type=${this.type}`, // 上传的图片服务器地址
        headers: {
          Authorization:
            'Bearer ' +
            localStorage.getItem(
              process.env.NODE_ENV === 'test'
                ? 'access_token_center_test'
                : 'access_token_center'
            ),
        },
      }
    },
    computed: {},
    created() {
      if (this.isId) {
        this.uploadFileUrl =
          process.env.VUE_APP_BASE_API +
          `power/system/file/uploadAttachment?type=${this.type}`
      }
    },
    methods: {
      handleExceed(files, fileList) {
        this.$message.warning(
          `当前限制选择 ${this.limit} 个文件，本次选择了 ${
            files.length
          } 个文件，共选择了 ${files.length + fileList.length} 个文件`
        )
      },
      // 上传前校检格式和大小
      async handleBeforeUpload(file) {
        console.log('🚀 ~ handleBeforeUpload ~ file:', file)
        // 校检文件类型
        if (this.fileType) {
          let fileExtension = ''
          if (file.name.lastIndexOf('.') > -1) {
            fileExtension = file.name.slice(file.name.lastIndexOf('.') + 1)
          }
          const isTypeOk = this.fileType.some((type) => {
            if (file.type.indexOf(type) > -1) return true
            if (fileExtension && fileExtension.indexOf(type) > -1) return true
            return false
          })
          if (!isTypeOk) {
            this.$message.error(
              `文件格式不正确, 请上传${this.fileType.join('/')}格式文件!`
            )
            return false
          }
        }

        // 校检文件大小
        if (this.fileSize) {
          const isLt = file.size / 1024 / 1024 < this.fileSize
          if (!isLt) {
            this.$message.error(`上传文件大小不能超过 ${this.fileSize} MB!`)
            return false
          }
        }
        if (
          file.type != 'application/pdf' ||
          file.type != 'application/msword' ||
          file.type != 'application/vnd.ms-excel'
        ) {
          const img = new Image()
          img.src = URL.createObjectURL(file)
          img.onload = () => {
            console.log('🚀 ~ handleBeforeUpload ~ img.width:', img.width)
            console.log('🚀 ~ handleBeforeUpload ~ img.height:', img.height)
            if (img.width > 8192 || img.height > 8192) {
              this.$message.error('图片宽度或高度不能大于8192px!')
              return false
            } else {
              return true // 通过验证，可以继续上传
            }
          }
          if (this.fileType.indexOf('mp4') == -1) {
            img.onerror = () => {
              this.$message.error('图片加载失败，请检查图片格式！')
              return false
            }
          }
        }

        return true
      },
      // 上传失败
      handleUploadError(err) {
        this.$message.error('上传失败, 请重试', err)
      },
      // 上传成功回调
      handleUploadSuccess(res) {
        if (res.code == 200) {
          this.$emit('uploadSuccess', res.data)
        } else {
          this.$message.error(res.msg)
        }
      },
    },
  }
</script>

<style scoped lang="scss">
  .upload-file-uploader {
    margin-bottom: 5px;
  }
  .upload-file-list .el-upload-list__item {
    border: 1px solid #e4e7ed;
    line-height: 2;
    margin-bottom: 10px;
    position: relative;
  }
  .upload-file-list .ele-upload-list__item-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: inherit;
  }
  .ele-upload-list__item-content-action .el-link {
    margin-right: 10px;
  }
</style>
